import React from "react";
import { AutomaticPayouts } from "app/userManagement/modules/generic";

const AdminAutomaticPayouts = () => {
  return <AutomaticPayouts />;
};
export default AdminAutomaticPayouts;
